import { useMemo } from 'react';
import { useLocaleContext } from '@shared/core/i18n/LocaleContext';
import { DateFormat, formatDateForLanguage, FormatDateOptions, NullableDateInput } from './dateFormatter';
export { formatDateForLanguage, getDateFormatterForLanguage } from './dateFormatter';

export const useFormattedDate = (input: NullableDateInput, format: DateFormat, options?: FormatDateOptions): string | undefined => {
  const { language } = useLocaleContext();
  return useMemo(() => formatDateForLanguage(language, input, format, options), [input, format, options, language]);
};
